// ProfileContext.js
import React, { createContext, useContext, useState } from 'react';

const ProfileContext = createContext();

export function ProfileProvider({ children }) {
  const [profileView, setProfileView] = useState(null);

  const showProfile = (userMetadata, pubkey) => {
	setProfileView({ userMetadata, pubkey });
  };

  const hideProfile = () => {
	setProfileView(null);
  };

  return (
	<ProfileContext.Provider value={{ showProfile, hideProfile, profileView }}>
	  {children}
	</ProfileContext.Provider>
  );
}

export function useProfile() {
  const context = useContext(ProfileContext);
  if (!context) {
	throw new Error('useProfile must be used within a ProfileProvider');
  }
  return context;
}